// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cd9a78b0","239":"0273eaee","453":"ee42fba2","455":"061cb9bc","977":"52dcab6c"}[chunkId] + ".chunk.js";
};